import {
	LIQUID_VARIABLE_NODE,
	liquidInlineContent,
} from '@dealstack/frontend/shared/components/EmailTemplates/extensions/liquidVariableNodes';
import type { Editor, JSONContent } from '@tiptap/core';

export const subjectToContent = (subject: string): JSONContent => ({
	type: 'doc',
	content: liquidInlineContent(subject),
});

export const subjectToText = (editor: Editor | null): string => {
	if (!editor) {
		return '';
	}
	let text = '';
	editor.state.doc.content.forEach((node) => {
		if (node.isText) {
			text += node.text ?? '';
		} else if (node.type.name === LIQUID_VARIABLE_NODE) {
			text += `{{ ${node.attrs.name as string} }}`;
		}
	});
	return text;
};
